import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AirplaneIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22 15.6899L13.555 13.0649L13.555 18.845L15.6789 20.4351V22L11.9874 20.9651L8.32111 22V20.4351L10.3944 18.845L10.3944 13.0649L2 15.6899L2 13.6202L10.3944 8.34495V2.5649C10.3944 2.1274 10.5461 1.75721 10.8496 1.45433C11.153 1.15144 11.5322 1 11.9874 1C12.4425 1 12.8175 1.15144 13.1125 1.45433C13.4075 1.75721 13.555 2.1274 13.555 2.5649V8.34495L22 13.6202V15.6899Z'
                fill='currentColor'
            />
        </>
    ),
})

AirplaneIcon.displayName = 'AirplaneIcon'
